import collasibles from './collapsible--test-event';
import pageUpdateNative from './page-update--native';
import pageUpdateBundle from './page-update--bundle';
import pageUpdateModule from './page-update--module';
import pageUpdatePoll from './page-update--poll';
import pageSettings from './test-page-settings';
// import pageUpdateViaSettings from './page-update--via-settings';

export default function() {
    collasibles();
    pageUpdateNative();
    pageUpdateBundle();
    pageUpdateModule.add();
    pageUpdatePoll();
    pageSettings();
}
